import type { ReactNode } from "react";

interface VariantSampleProps {
  label: string;
  children: ReactNode;
}

export const VariantSample = ({ label, children }: VariantSampleProps) => (
  <div className="flex flex-col items-center gap-1.5">
    {children}
    <span className="text-center text-xs text-muted-foreground">{label}</span>
  </div>
);
